import Toastr from "../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  connect_devices: [],
  connect_device: {},
  meta: { pagination: {} },
  saving: false,
  editing: false
}

let changes = null;
export default function connectDevicesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let devices = [];
  let deviceData = [];
  let updatedRecord = {};

  switch (action.type) {
    case `CONNECT_DEVICES_CREATE_PENDING`:
    case `CONNECT_DEVICES_UPDATE_PENDING`:
    case `CONNECT_DEVICES_DELETE_PENDING`:
      return { ...state, saving: true };

    case `CONNECT_DEVICES_LOAD_REJECTED`:
    case `CONNECT_DEVICE_LOAD_REJECTED`:
    case `CONNECT_DEVICE_CREATE_REJECTED`:
    case `CONNECT_DEVICE_UPDATE_REJECTED`:
    case `CONNECT_DEVICE_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case `CONNECT_DEVICES_LOAD_FULFILLED`:
      changes = {
        meta: response.meta,
        connect_devices: response.integrated_devices || [],
        saving: false
      };
      return { ...state, ...changes };

    case `CONNECT_DEVICE_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.connect_devices]
      let newRecord = response.integrated_device
      changes = {
        connect_devices: [newRecord, ...devices],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case `CONNECT_DEVICE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.connect_devices];
      updatedRecord = response.integrated_device;
      for (const [index, key] of devices.entries()) {
        if (key.id === updatedRecord.id) {
          deviceData = [
            ...devices.slice(0, index),
            updatedRecord,
            ...devices.slice(index + 1)
          ];
        }
      }
      changes = {
        connect_devices: deviceData.length ? deviceData : [updatedRecord, ...devices],
        saving: false
      };
      return { ...state, ...changes };

    case `CONNECT_DEVICE_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.connect_devices];
      for (const [index, key] of devices.entries()) {
        if (key.id === response.integrated_device.id) {
          devices.splice(index, 1);
        }
      }
      return {
        ...state,
        connect_devices: devices,
      };

    case `CONNECT_DEVICE_EDIT`:
      changes = {
        editing: action.data,
      };
      return { ...state, ...changes };

    case `CONNECT_DEVICE_EDIT_CANCEL`:
      changes = {
        editing: false,
        connect_device: {}
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}
